export default {
    state: {
        dialogVisible: false,
    },
    show() {
        this.state.dialogVisible = true;
    },
    dismiss() {
        this.state.dialogVisible = false;
    }
}
